import { render, staticRenderFns } from "./instaFeed.vue?vue&type=template&id=178541e0&scoped=true"
import script from "./instaFeed.vue?vue&type=script&lang=js"
export * from "./instaFeed.vue?vue&type=script&lang=js"
import style0 from "./instaFeed.vue?vue&type=style&index=0&id=178541e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178541e0",
  null
  
)

export default component.exports